import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AccountNumberValidationService {

  constructor() {
  }

  //*check Account Number contains 8-9 digits*/
  validateAccountNumber(accountNumber) {
    // If no input yet, don't show validation error
    if (!accountNumber || accountNumber === '') {
      return false; // Valid (no error)
    }
    // Handle both formats: with dash (1234-5678) and without dash (12345678)
    const accountNumWithNoDash = accountNumber.replace(/-/g, '');
    return accountNumWithNoDash.length < 8;
  }
}
